import { render, staticRenderFns } from "./OptionMng.vue?vue&type=template&id=73fdbf6a&scoped=true"
import script from "./OptionMng.vue?vue&type=script&lang=js"
export * from "./OptionMng.vue?vue&type=script&lang=js"
import style0 from "./OptionMng.vue?vue&type=style&index=0&id=73fdbf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdbf6a",
  null
  
)

export default component.exports